<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter RBAC Roles</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close Filter RBAC Roles"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="rbac_permissions">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectPermissions()"
        [matBadge]="'' + (filters.rbac_permission_ids.length || 'All')"
        class="mx-3 mt-2"
        matTooltip="Filter the roles by the permissions they grant.">
        <mat-icon>verified_user</mat-icon> Permissions
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.user_ids.length || 'All')"
        class="mx-3 mt-2"
        [matTooltip]="'Filter the roles by the assigned ' + utils.getLangTerm('employees.plural', 'Employees').toLowerCase() + '.'">
        <mat-icon>account_circle</mat-icon> {{ utils.getLangTerm('employees.plural', 'Employees') }}
      </button>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()"
        matTooltip="Apply the selected filters to the list.">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()"
        matTooltip="Clear all filters and reload the list.">
        <mat-icon>clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
